import React from 'react';
import styles from './designMenuBar.module.scss';

type Props = {
	children?: React.ReactNode;
};

export const MenuBar: React.FC<Props> = ({ children }) => <div className={styles.barContainer}>{children}</div>;
